<div *ngIf="pageLoaded$ | async" class="container">
	<div class="pages">
		<nav>
			<ng-container *ngFor="let link of (siteData$ | async)?.footer" [ngSwitch]="link.type">
				<a *ngSwitchCase="'internal'" [routerLink]="link.url ?? '.'" [fragment]="link.fragment" [target]="(isStandalonePage$ | async) ? '_blank' : '_self'">{{ link.title }}</a>
				<a *ngSwitchCase="'external'" [href]="link.url" [target]="link.target || '_blank'" rel="noreferrer">{{ link.title }}</a>
			</ng-container>
		</nav>
	</div>
	<div class="social">
		<nav>
			<a *ngFor="let link of (siteData$ | async)?.socialAccounts | keyvalue" [href]="link.value" target="_blank" rel="noreferrer">
				<span [inlineSVG]="'/assets/img/icons/' + link.key + '.svg'" [setSVGAttributes]="{ role: 'img', 'aria-label': link.key }"></span>
			</a>
		</nav>
	</div>
</div>
